<template>
  <div class="ysb-cascader">
    <Cascader
      v-model:value="modelValue"
      :options="options"
      :placeholder="placeholder"
      :load-data="antLoadData"
      :style="{ width }"
      :change-on-select="changeOnSelect"
      :show-search="showSearch"
      :display-render="displayRender"
      :field-names="fieldNames"
      :expand-trigger="expandTrigger"
      :disabled="disabled"
      @change="handleChange"
      @search="handleSearch"
    />
  </div>
</template>
<script lang="ts">
export default {
  name: 'YCascaderPc'
}
</script>
<script lang="ts" setup>
import { cascaderProps, Option } from './cascader'
import { useVModel } from '@vueuse/core'
import { Cascader } from 'ant-design-vue'
import 'ant-design-vue/es/cascader/style/css'
import type { ShowSearchType } from 'ant-design-vue/es/cascader'

const props = defineProps(cascaderProps)
const emit = defineEmits(['update:value', 'change'])
const modelValue = useVModel(props, 'value', emit)
const labelKey = props.fieldNames.label ?? 'label'

const antLoadData =
  !props.loadData || props.remoteSearch
    ? undefined
    : function (selectedOptions: any) {
        new Promise<Option[]>((resolve) => {
          props.loadData!(selectedOptions, resolve)
        }).then((options) => {
          selectedOptions[selectedOptions.length - 1].children = options
        })
      }

function handleChange(val: any, selectedOptions: Option[]) {
  emit('change', selectedOptions)
  if (val === undefined) modelValue.value = []
}

const filter: ShowSearchType['filter'] =
  typeof props.filter === 'function'
    ? props.filter
    : function (inputValue, path) {
        return path.some((option) =>
          option[labelKey]?.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
const showSearch = props.remoteSearch || props.filter ? { filter } : false
async function handleSearch(inputValue: string) {
  if (props.remoteSearch) {
    await new Promise<void>((resolve) => {
      props.remoteSearch!(inputValue, resolve)
    })
  }
}
</script>
